<div class="rts-welcome-container text-center" ngClass.lt-md="mobile">
  <div
    class="pad top-7x"
    fxLayout="column"
    fxLayoutGap="16px"
    fxLayoutAlign="center center"
  >
    <mat-icon svgIcon="dollar-pin-white"></mat-icon>
    <h2 [innerHTML]="'rts_welcome_header' | translate" class="text-bold"></h2>
  </div>
  <div
    [innerHTML]="'rts_welcome_description' | translate"
    class="description pad top-3x dls-subhead-3-regular"
  ></div>
  <div
    fxHide.lt-md
    fxLayout="row"
    fxLayoutAlign="center stretch"
    fxLayoutGap="16px"
    class="card-container margin top-3x"
  >
    <div
      fxFlex="33"
      class="rts-card"
      *ngFor="let procedure of procedures | slice: 0:4; trackBy: trackById"
    >
      <div fxLayout="column" fxLayoutAlign="space-between stretch" fxFlexFill>
        <h3 class="procedure-name text-left pad left-1x dls-subhead-3-bold">
          {{
            'rts_procedure_name_' + procedure.rts_category?.toLowerCase()
              | translate: { drug: procedure?.name }
          }}
        </h3>
        <div>
          <div class="reward-container">
            <h4 class="text-bold dls-body-1-regular -mb-6">
              {{ 'rts_welcome_card_rewards' | translate }}
            </h4>
            <br />
            <h4 class="dls-subhead-1-bold">
              {{
                procedure.high_incentive_amount
                  | currency: 'USD':'symbol':'1.0-0'
              }}
            </h4>
          </div>
          <div class="cta-container">
            <button
              type="button"
              class="text-bold link-blue view-button"
              (click)="searchProcedure(procedure)"
            >
              {{ 'rts_welcome_card_cta' | translate }}
              <mat-icon
                svgIcon="dls-angle-plain-right-light"
                class="right-arrow-icon"
              ></mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile -->
  <div
    fxHide.gt-sm
    fxLayout="column"
    fxLayoutAlign="start stretch"
    fxLayoutGap="8px"
    class="pad top-3x"
  >
    <div class="text-right reward-text">
      {{ 'rts_welcome_card_rewards' | translate }}
    </div>
    <div *ngFor="let procedure of procedures | slice: 0:4; trackBy: trackById">
      <div
        fxLayout="row"
        class="procedure-row"
        (click)="searchProcedure(procedure)"
      >
        <div fxFlex="80" class="text-left pad bottom-1x">
          {{
            'rts_procedure_name_' + procedure.rts_category?.toLowerCase()
              | translate: { drug: procedure?.name }
          }}
        </div>
        <div fxFlex="10">
          {{
            procedure.high_incentive_amount | currency: 'USD':'symbol':'1.0-0'
          }}
        </div>
        <a fxFlex="10" (click)="searchProcedure(procedure)">
          <mat-icon
            class="right-arrow-icon h-6"
            svgIcon="dls-angle-plain-right-light"
          ></mat-icon>
        </a>
      </div>
    </div>
  </div>
  <zelis-button
    appGtm
    [gtmOnClick]="true"
    [gtmData]="{ event: 'gtm.rts.homepage_learn_about_the_program' }"
    [forwardedClass]="['mt-10', 'mb-12', 'link-blue']"
    [routerLink]="['marketing/right-to-shop']"
    queryParamsHandling="preserve"
    variant="flat"
    color="white"
    size="large"
  >
    {{ 'rts_welcome_cta' | translate }}
  </zelis-button>
</div>
